<div class="px-0 py-0 grid grid-cols-1 md:grid-cols-2 gap-4">
  <!-- Topo: 2 gráficos lado a lado em desktop, empilhados em mobile -->
  <div class="min-w-0 h-full">
    <app-top-selling-products-chart></app-top-selling-products-chart>
  </div>
  <div class="min-w-0 h-full">
    <app-top-cancelled-products-chart></app-top-cancelled-products-chart>
  </div>

  <!-- Abaixo: comparação semanal ocupando toda a largura -->
  <div class="min-w-0 h-full md:col-span-2">
    <app-sales-production-chart></app-sales-production-chart>
  </div>
</div>
